import React from "react"
import { Listbox } from "@headlessui/react"
import { CheckIcon, ChevronDownIcon } from "@heroicons/react/24/solid"
import classNames from "~/utils/classNames"
import { IDropdownProps } from "./interfaces/DropdownProps"

const DropdownSelector = ({
  value,
  onChange,
  options,
  disabled,
  label,
  dropdownClassNames,
  hideNullValueOption,
}: IDropdownProps) => {
  const filteredOptions = options?.filter((option) => !hideNullValueOption || option.value !== null)

  return (
    <>
      <Listbox value={value} onChange={onChange} disabled={disabled}>
        {({ open }) => (
          <>
            <div className={classNames("relative", dropdownClassNames)}>
              <div className="flex items-center">
                <Listbox.Button
                  className={classNames(
                    "rounded-md items-left inline-flex justify-between items-center w-full border border-gray-300 shadow-sm px-4 py-2.5 bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-gray-100",
                    disabled && "cursor-not-allowed",
                  )}
                >
                  {filteredOptions?.length && !!value
                    ? filteredOptions.find((option) => String(option.value) === String(value))?.label
                    : label}
                  <ChevronDownIcon className="ml-2 h-5 w-5" aria-hidden="true" />
                </Listbox.Button>
              </div>

              <Listbox.Options className="absolute w-auto min-w-full right-0 z-10 mt-1 bg-white shadow-lg max-h-60 rounded-md py-1 text-base overflow-auto focus:outline-none">
                {filteredOptions?.map((option) => (
                  <Listbox.Option
                    key={option.value}
                    className={({ active }) =>
                      classNames(active ? "bg-gray-100" : "", "cursor-pointer select-none relative py-2 pl-3 pr-9")
                    }
                    value={option.value}
                  >
                    {({ selected, active }) => (
                      <>
                        <span className={classNames(selected ? "font-semibold" : "font-normal", "block truncate")}>
                          {option.label}
                        </span>
                        {selected && (
                          <span
                            className={classNames(
                              active ? "text-amber-600" : "text-amber-600",
                              "absolute inset-y-0 right-0 flex items-center pr-4",
                            )}
                          >
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        )}
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </div>
          </>
        )}
      </Listbox>
    </>
  )
}

export default DropdownSelector
